import React, { useContext } from "react";
import { AdminAuthContext } from "../../context/AdminAuthContext";

const PrivateRouteAdmin = ({ setAdminLoginModal, children, ...rest }) => {
  const { user, loading } = useContext(AdminAuthContext);
  if (loading) {
    return (
      <div className="spinner">
        <h6>loading...</h6>;
      </div>
    );
  }

  if (!user) {
    return setAdminLoginModal(true);
  }
  return children;
};

export default PrivateRouteAdmin;
